// extracted by mini-css-extract-plugin
export default {"wrapper":"StaticPage_wrapper__KgCp2","noWrap":"StaticPage_noWrap__sXxzp","dotEnded":"StaticPage_dotEnded__spzLK","acceptButton":"StaticPage_acceptButton__1jUV7"};